import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, of, Subject, throwError } from "rxjs";
import {
  catchError,
  concatMap,
  delay,
  filter,
  map,
  mergeMap,
  retry,
  retryWhen,
  switchMap,
  take,
  tap,
} from "rxjs/operators";


import { JSEncrypt as JSEncrypt1 } from "jsencrypt";
const JSEncrypt = require('jsencrypt')
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
const FormData = require('form-data');

import { EncryptionDecryptionService } from "./encryption-decryption.service";
import { json } from "express";
// import { ResultFunc } from "rxjs/internal/observable/generate";
// import "rxjs/add/observable/fromPromise";
// import "rxjs/add/operator/mergeMap";
@Injectable({
  providedIn: "root",
})
export class EncryptionDecryptionIntercepter implements HttpInterceptor {
  rsaAlgorithm:any;
  isBrowser: boolean;

  //,'api/ApiInvoker/InvokeWithFiles'
  secureUrls = [];
  arrayOfFiles:any = ["GetProductSerialTemplate"];
  nonSigntureExcludedApi = [
    "assets/bundels/modules.json",
    "pages/SavePageSettings",
    "PageTemplate/SaveTemplatesSettings",
    "PageTemplate/SetTemplateCSS",
    "/CPAPI/",
    "/ApiMapper/",
    "GetTemplateOfBulkCouponAddition",
    "/SharedSetupAPI/",
    ".json",
    "api/Pages/AddEditPage",
    
    "orders/export",
    "GetProductSerialTemplate",
    "orders/lines-export",
    window['config'].coreURL?window['config'].coreURL:'AhmadAlkhadraa',
  "/invoices/print"
    //"EmailTemplate/addTemplate",
	 // "EmailTemplate/EditTemplate",
	  // "NewsLetter/UpsertNewsLetter",
	//  "Elements/ShareElement",
  ];




  handshaking = false;
  handshakingSuccessfull = new Subject<any>();
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private ES: EncryptionDecryptionService,
    private http: HttpClient
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.rsaAlgorithm = new JSEncrypt1();
    } else {
      this.rsaAlgorithm = new JSEncrypt();
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    for (let i = 0; i < this.nonSigntureExcludedApi.length; i++) {
      if (
        req.url
          .toLowerCase()
          .includes(this.nonSigntureExcludedApi[i].toLowerCase())
      ) {
        return next.handle(req).pipe(
          map((result: HttpEvent<any>) => {
            return result;
          })
        );
      }
    }
    //majorSalt
    // handshaking
    if (req.url.includes("/Account/HandShake")) {
      let cloneReq = req.clone({
        setHeaders: {
          handshaking: this.ES._getFrontendPublicKeyB64FromLocalStorage()
        }
      });
      return next.handle(cloneReq).pipe(
        map((result: HttpEvent<any>) => {
          if (result instanceof HttpResponse) {
            result = this.ES.handle_hanshaking_signture(result);
          }
          return result;
        })
        // Commented by Israa because after uncommenting this refresh token is not being called
        // catchError((err) => {
        //   // throw new Error(err.error);

        //   // To Fix Refresh Token Issue
        //   ///
        //   return throwError(err);
        // })
      );
    }
    for (let i = 0; i < this.secureUrls.length; i++) {
      if (req.url.toLowerCase().includes(this.secureUrls[i].toLowerCase())) {
        if (!this.ES.isHandshaked()) {
          if (!this.handshaking) {
            this.handshaking = true;
            return this.ES.handShaking().pipe(
              switchMap(res => {
                if (res) {
                  this.handshaking = false;
                  let cloneReq = this.handle_EN_DE_Request(req);
                  return next.handle(cloneReq).pipe(
                    map((result: HttpEvent<any>) => {
                      if (result instanceof HttpResponse) {
                        this.handshakingSuccessfull.next(true);
                        result.body.content = this.handle_EN_DE_Response(
                          result
                        );
                      }
                      return result;
                    })
                  );
                }
              })
            );
          } else {
            return this.handshakingSuccessfull.pipe(
              take(1),
              switchMap(res => {
                if (res) {
                  let cloneReq = this.handle_EN_DE_Request(req);
                  return next.handle(cloneReq).pipe(
                    map((result: HttpEvent<any>) => {
                      if (result instanceof HttpResponse) {
                        result.body.content = this.handle_EN_DE_Response(
                          result
                        );
                      }
                      return result;
                    }),
                    catchError(err => {
                      if (err.status == 412) {
                        if (!this.handshaking) {
                          this.handshaking = true;
                          return this.ES.handShaking().pipe(
                            switchMap(res => {
                              if (res) {
                                this.handshaking = false;
                                let cloneReq = this.handle_EN_DE_Request(req);
                                return next.handle(cloneReq).pipe(
                                  map((result: HttpEvent<any>) => {
                                    if (result instanceof HttpResponse) {
                                      this.handshakingSuccessfull.next(true);
                                      result.body.content = this.handle_EN_DE_Response(
                                        result
                                      );
                                    }
                                    return result;
                                  })
                                );
                              }
                            })
                          );
                        } else {
                          return this.handshakingSuccessfull.pipe(
                            take(1),
                            switchMap(res => {
                              if (res) {
                                let cloneReq = this.handle_EN_DE_Request(req);
                                return next.handle(cloneReq).pipe(
                                  map((result: HttpEvent<any>) => {
                                    if (result instanceof HttpResponse) {
                                      result.body.content = this.handle_EN_DE_Response(
                                        result
                                      );
                                    }
                                    return result;
                                  })
                                );
                              }
                            })
                          );
                        }
                      }
                      return throwError(err);
                    })
                  );
                }
              })
            );
          }
        } else {
          let cloneReq = this.handle_EN_DE_Request(req);
          return next.handle(cloneReq).pipe(
            map((result: HttpEvent<any>) => {
              if (result instanceof HttpResponse) {
                result.body.content = this.handle_EN_DE_Response(result);
              }
              return result;
            }),
            catchError(err => {
              if (err.status == 412) {
                if (!this.handshaking) {
                  this.handshaking = true;
                  return this.ES.handShaking().pipe(
                    switchMap(res => {
                      if (res) {
                        this.handshaking = false;
                        let cloneReq = this.handle_EN_DE_Request(req);
                        return next.handle(cloneReq).pipe(
                          map((result: HttpEvent<any>) => {
                            if (result instanceof HttpResponse) {
                              this.handshakingSuccessfull.next(true);
                              result.body.content = this.handle_EN_DE_Response(
                                result
                              );
                            }
                            return result;
                          })
                        );
                      }
                    })
                  );
                } else {
                  return this.handshakingSuccessfull.pipe(
                    take(1),
                    switchMap(res => {
                      if (res) {
                        let cloneReq = this.handle_EN_DE_Request(req);
                        return next.handle(cloneReq).pipe(
                          map((result: HttpEvent<any>) => {
                            if (result instanceof HttpResponse) {
                              result.body.content = this.handle_EN_DE_Response(
                                result
                              );
                            }
                            return result;
                          })
                        );
                      }
                    })
                  );
                }
              }
              return throwError(err);
            })
          );
        }
      }
    }

    if (!this.ES.isHandshaked()) {
      this.handshaking = true;
      return this.ES.handShaking().pipe(
        switchMap(res => {
          if (res) {
            this.handshaking = false;
            let cloneReq = this.handleSigntureRequest(req);
            return next.handle(cloneReq).pipe(
              map((result: HttpEvent<any>) => {
                if (result instanceof HttpResponse) {
                  result = this.handleSignatureResponse(result);
                }
                return result;
              }),
              catchError(err => {
                if (err.status == 412) {
                  if (!this.handshaking) {
                    this.handshaking = true;
                    return this.ES.handShaking().pipe(
                      switchMap(res => {
                        if (res) {
                          this.handshaking = false;
                          let cloneReq = this.handleSigntureRequest(req);
                          return next.handle(cloneReq).pipe(
                            map((result: HttpEvent<any>) => {
                              if (result instanceof HttpResponse) {
                                result = this.handleSignatureResponse(result);
                              }
                              return result;
                            })
                          );
                        }
                      })
                    );
                  } else {
                    return this.handshakingSuccessfull.pipe(
                      take(1),
                      switchMap(res => {
                        if (res) {
                          let cloneReq = this.handleSigntureRequest(req);
                          return next.handle(cloneReq).pipe(
                            map((result: HttpEvent<any>) => {
                              if (result instanceof HttpResponse) {
                                result = this.handleSignatureResponse(result);
                              }
                              return result;
                            })
                          );
                        }
                      })
                    );
                  }
                }
                return throwError(err);
              })
            );
          }
        })
      );
    } else {
      let cloneReq = this.handleSigntureRequest(req);
      return next.handle(cloneReq).pipe(
        map((result: HttpEvent<any>) => {
          if (result instanceof HttpResponse) {
            result = this.handleSignatureResponse(result);
          }
          return result;
        }),
        catchError(err => {
          if (err.status == 412) {
            if (!this.handshaking) {
              this.handshaking = true;
              return this.ES.handShaking().pipe(
                switchMap(res => {
                  if (res) {
                    this.handshaking = false;
                    let cloneReq = this.handleSigntureRequest(req);
                    return next.handle(cloneReq).pipe(
                      map((result: HttpEvent<any>) => {
                        if (result instanceof HttpResponse) {
                          result = this.handleSignatureResponse(result);
                        }
                        return result;
                      })
                    );
                  }
                })
              );
            } else {
              return this.handshakingSuccessfull.pipe(
                take(1),
                switchMap(res => {
                  if (res) {
                    let cloneReq = this.handleSigntureRequest(req);
                    return next.handle(cloneReq).pipe(
                      map((result: HttpEvent<any>) => {
                        if (result instanceof HttpResponse) {
                          result = this.handleSignatureResponse(result);
                        }
                        return result;
                      })
                    );
                  }
                })
              );
            }
          }
          return throwError(err);
        })
      );
    }
  }

  handleSigntureRequest(request: HttpRequest<any>) {
    if (request.body) {
      var stringifiedDataReq = request.body;
      if (request.body instanceof FormData) {
        stringifiedDataReq = "";
        let formData = [];

        // let keys=  Object.keys(request.body);
        // request.body.forEach((val) => {
        //   if(val !='[object File]')
        //   stringifiedDataReq = stringifiedDataReq  + val;
        // });
        request.body.forEach((val, key) => {
          if (val != "[object File]") {
            formData.push({ Key: key, Value: val });
          }
        });
        stringifiedDataReq = JSON.stringify(formData);
      } else if (
        typeof request.body != "string" &&
        !(request.body instanceof FormData)
      ) {
        stringifiedDataReq = JSON.stringify(request.body);
      }
    } else stringifiedDataReq = "";
    var type: any;
    if (request.body instanceof FormData) type = "FormData";
    else type = "JSON";

    let cloneReq = request.clone({
      setHeaders: {
        signature: this.ES.generateSignture(stringifiedDataReq),
        pointerId: this.ES._getPointerIdDecryptedByRsaFromLocalStorage(),
        oldContentType: type
      }
    });

    return cloneReq;
  }
  handleSignatureResponse(result) {
    if (this.ES.isJson(result.body)) {
      result = result.clone({
        body: JSON.parse(result.body)
      });
    }
    if (!result.body.content) {
      return result;
    }
    var stringifiedRes = result.body.content;
    var generatedSignture: any = this.ES.generateSignture(stringifiedRes);
    // if (result.body.signature != generatedSignture) {
    //   throw new Error(
    //     "invalid reponse signture other backend played with the response, bad backend!!"
    //   );
    // }
if(this.ES.isJson(result.body.content)){
  result.body.content = JSON.parse(result.body.content);
}else{
  result.body.content = result.body.content
}
   

    return result;
  }

  handle_EN_DE_Response(result) {
    if (this.ES.isJson(result.body)) {
      result = result.clone({
        body: JSON.parse(result.body)
      });
    }
    if (!result.body.content) {
      return result;
    }
    let x = JSON.parse(result.body.content);
    let decrypted = this.ES.decryptByAes(JSON.parse(x), result.body.major_salt);

    var generatedSignture: any = this.ES.generateSignture(decrypted);
    if (result.body.signature != generatedSignture) {
      // throw new Error(
      //   "invalid reponse signture other backend played with the response, bad backend!!"
      // );
    }
    return JSON.parse(decrypted);
  }
  handle_EN_DE_Request(request: HttpRequest<any>) {
    if (request.body) {
      var stringifiedDataReq = request.body;
      if (request.body instanceof FormData) {
        stringifiedDataReq = "";

        let formData = [];
        request.body.forEach((val, key) => {
          if (val != "[object File]") {
            formData.push({ Key: key, Value: val });
          } else this.arrayOfFiles.push({ Key: key, Value: val });
        });
        stringifiedDataReq = JSON.stringify(formData);
      } else if (typeof request.body != "string") {
        stringifiedDataReq = JSON.stringify(request.body);
      }
    } else stringifiedDataReq = "";
    let type = "";
    if (request.body instanceof FormData) type = "FormData";
    else type = "JSON";

    var form_data = new FormData();

    var arrayOfStringifiedBody: any = this.ES.encryptByAes(stringifiedDataReq);
    form_data.append("cipherText", arrayOfStringifiedBody);

    if (this.arrayOfFiles.length > 0) {
      for (let item of this.arrayOfFiles)
        form_data.append(item.Key, item.Value);
    }

    let cloneReq = request.clone({
      setHeaders: {
        signature: this.ES.generateSignture(stringifiedDataReq),
        pointerId: this.ES._getPointerIdDecryptedByRsaFromLocalStorage(),
        oldContentType: type,
        majorSalt: this.ES.ivB64
      },
      body: form_data
    });

    return cloneReq;
  }
}
